import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../App'
import { currentSessionWeather, fetchLiveWeather, subscribeWearWeather } from '../lib/wearLogContext'

// Current local weather for display. Works whether or not a wear is logged
// today; refreshes every 15 minutes while the screen is open. Every stored
// reading carries the account it belongs to and is returned only to that
// account — including the render right after a sign-in change — and a failed
// refresh clears it so a stale reading is never shown as current.
export function useLiveWeather({ enabled = true } = {}) {
  const { user } = useAuth()
  const userId = user?.id || null
  const [reading, setReading] = useState(() => ({ ownerId: userId, weather: currentSessionWeather(Date.now(), userId) }))

  useEffect(() => {
    setReading({ ownerId: userId, weather: currentSessionWeather(Date.now(), userId) })
    if (!enabled || !userId) return undefined
    let alive = true
    const load = () => fetchLiveWeather({ supabaseClient: supabase, expectedOwnerId: userId }).then(next => {
      if (alive) setReading({ ownerId: userId, weather: next || null })
    })
    load()
    const timer = setInterval(load, 15 * 60 * 1000)
    const unsubscribe = subscribeWearWeather(({ weather: next, ownerId }) => {
      if (alive && next && ownerId === userId) setReading({ ownerId, weather: next })
    })
    return () => { alive = false; clearInterval(timer); unsubscribe() }
  }, [enabled, userId])

  return enabled && userId && reading.ownerId === userId ? reading.weather : null
}
